import styled from 'styled-components';

export const StyledLabel = styled.label`
  font-weight: bold;
  margin-bottom: 1em;
`;
